var map = {
	"./01_GruppoYec.png": 7783,
	"./02_horto.png": 1507,
	"./03_NpMedia.png": 7136,
	"./04_Alfieri.png": 3239,
	"./05_Alegal.png": 4696,
	"./06_Meitei.png": 1020,
	"./07_Sonda.png": 8049,
	"./08_Tralerighe.png": 4686,
	"./09_EspressioneDanza.png": 9354,
	"./10_CentroMedicina.png": 5778,
	"./11_DlTecnologies.png": 4353,
	"./12_Hotel.png": 6658,
	"./13_Otherwise.png": 6670,
	"./14_Varaschin.png": 6706,
	"./15_Inquadra.png": 3440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9381;